import { PendingParameterChecks } from "./PendingParameterChecks";
import { groupConflictReasons } from "./groupConflictReasons";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { ParameterConflict } from "store/api/generatedApi";
import { parameterConflictSummaryKey } from "./parameterConflicts";

export const SaveDefaultsDialog = ({
  open,
  onClose,
  onConfirm,
  isSaving,
  isChecking,
  disabled,
  conflicts,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isSaving: boolean;
  isChecking: boolean;
  disabled: boolean;
  conflicts: ParameterConflict[];
}) => {
  const { t } = useTenantTranslation();
  const reasonCount = groupConflictReasons(conflicts).length;
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isSaving) onClose();
      }}
    >
      <DialogTitle>{t("confirmSaveTitle")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("confirmSaveDefaults")}</DialogContentText>
        {isChecking ? <PendingParameterChecks /> : null}
        {conflicts.length > 0 ? (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {t(parameterConflictSummaryKey(reasonCount), {
              count: reasonCount,
            })}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSaving}>
          {t("cancel")}
        </Button>
        <Button
          onClick={() => void onConfirm()}
          variant="contained"
          disabled={disabled || isSaving}
        >
          {isSaving ? t("saving") : t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
